<template>
  <div class="wrap">
    <form @submit.prevent="sendToAll" class="form-el">
      <button-el :disabled="sendingInProgress" red>Send to all subscribed users</button-el>
    </form>
    <form @submit.prevent="sendToSpecific" class="form-el">
      <input-el v-model="email" required class="input-el" label="Specific email" />
      <button-el :disabled="sendingInProgress">Send to specific email</button-el>
    </form>
  </div>
</template>

<script>
const emailSendingTargets = {
  all: 'all',
  specific: 'specific',
};

export default {
  data: () => ({
    email: null,
    sendingInProgress: false,
  }),
  methods: {
    sendToAll() {
      this.sendingInProgress = true;
      this.$apiService.sendSubscriptionEmail(emailSendingTargets.all).then(() => {
        alert('Emails are sent to all subscribers'); // eslint-disable-line no-alert
      }).finally(() => {
        this.sendingInProgress = false;
      });
    },
    sendToSpecific() {
      this.sendingInProgress = true;
      this.$apiService.sendSubscriptionEmail(emailSendingTargets.specific, this.email).then(() => {
        alert(`Email is sent to ${this.email}`); // eslint-disable-line no-alert
      }).finally(() => {
        this.sendingInProgress = false;
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.wrap {
  display: flex;
  justify-content: center;
  align-items: bottom;
}
.form-el:first-child {
  margin-right: 30px;
  margin-right: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.btn {
  max-width: 250px !important;
}
.input-el {
  margin-bottom: 10px;
  width: 254px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/admin/EmailSending.vue